'use client'
import { PaymentMethods } from 'api-graphql-types'
import { Icon, type IconName } from 'design-system/client'
import styles from './PaymentMethodIcon.module.css'
import classNames from 'classnames'

const iconsToPaymentMethodMap = {
  [PaymentMethods.DirectDeposit]: 'wireTransfer' as IconName,
  [PaymentMethods.Paypal]: 'payPal' as IconName,
  [PaymentMethods.StripeApplePay]: 'applePay' as IconName,
  [PaymentMethods.StripeGooglePay]: 'googlePay' as IconName,
  [PaymentMethods.StripeSepaDebit]: 'sepa' as IconName,
  [PaymentMethods.StripeCc]: 'creditCard' as IconName,
  [PaymentMethods.DummyPayment]: 'creditCard' as IconName,
  [PaymentMethods.StripeWero]: 'wero' as IconName,
}

function PaymentMethodIcon({ name, className }: { name: PaymentMethods; className?: string }) {
  return <Icon name={iconsToPaymentMethodMap[name]} className={classNames(styles.paymentMethodIcon, className)} />
}

export default PaymentMethodIcon
